import React from 'react';
import { IconButton } from 'fronton-react';
import { XCircleIcon } from '@fronton/icons-react';
import { ButtonCloseBannerProps } from '../types';

export function ButtonCloseBanner(props: Readonly<ButtonCloseBannerProps>) {
  const { backgroundColor, onHiddenBanner, showCloseButton, handleClickButtonToGA } = props;

  const invert = backgroundColor === 'rgb(255,255,255)';

  const handleClick = (event: React.MouseEvent) => {
    handleClickButtonToGA();
    onHiddenBanner(event);
  };

  if (!showCloseButton) return null;

  return (
    <IconButton size="m" label="close-banner" invert={!invert} onClick={handleClick}>
      <XCircleIcon type="fill" />
    </IconButton>
  );
}
